<template>
  <b-form  @keyup.enter="keySearch">
    <el-row>
      <el-col :span="24">
        <el-input
                :placeholder="$l('dialog_ppt_search_label_template_name')||'模板名称'"
                size="medium"
                class="input-with-select"
                v-model="form.templateName"
                clearable
        >
          <dict-select
                  url="/digitalCenter/common/dict/masterCategory"
                  v-model="form.categoryCode"
                  :placeholder="$l('dialog_ppt_search_label_sample_category')||'请选择产品类别'"
                  slot="prepend"
                  filterable
                  clearable
          ></dict-select>
          <el-button slot="append" icon="el-icon-search" @click="keySearch"></el-button>
        </el-input>
      </el-col>
    </el-row>
  </b-form>
</template>

<script>
export default {
  data () {
    return {
      form: {
        templateName: '',
        categoryCode: ''
      }
    }
  },
  methods: {
    query () {
      this.$emit('submit', this.form)
    },
    reset () {
      this.$refs.form.resetFields()
      this.query()
    },
    keySearch() {
      this.query()
    },
  },
  created () {
    this.query()
  }
}
</script>
